module.exports = __webpack_public_path__ + "img/3-2.56895801.png";